import { useCallback } from "react";
import { useFetch } from "../infrastructure/useFetch";
import { Config } from "../config";
import { User } from "./models/User";

export type GetTokenFromCodeSuccess = {
  access_token: string,
  expires_in: number
};

export function useLogin() {
  const client = useFetch();
  const getTokenFromCode = useCallback(
    async (payload: { code: string; redirect_uri: string }) => {
      const result = await client.postAsAnon<GetTokenFromCodeSuccess>(
        Config.AUTH_API_URL + "/token_from_code",
        payload,
        {
          headers: {},
          withCredentials: true
        }
      );

      return result.data;
    },
    []
  );

  const refreshToken = useCallback(async () => {
    const result = await client.post<GetTokenFromCodeSuccess>(
      Config.AUTH_API_URL + "/refresh_token",
      {},
      {
        headers: {},
        withCredentials: true
      }
    );

    return result.data;
  }, []);

  const getCurrentUser = useCallback(async () => {
    const result = await client.get<User>(
      Config.BASE_RCT_API_URL + "/user/?format=json",
      { withCredentials: false }
    );
    return result.data;
  }, []);

  const getMetaCurrentUser = useCallback(async () => {
    const result = await client.get<User>(
      Config.BASE_API_URL + "/user/?format=json",
      { withCredentials: false }
    );
    return result.data;
  }, []);

  return {
    getCurrentUser,
    getMetaCurrentUser,
    getTokenFromCode,
    refreshToken
  };
}
